import { parseFetchError } from '../../utils/http';
import { config } from '../../config';
import {
  getStoredToken,
  sessionChecker,
  sessionCloser,
} from './SessionChecker';
import { sendMultiPartRequest } from 'services/base/sendRequest';

const signIn = (data, _onSuccess) => {
  return new Promise(async (resolve, reject) => {
    const onSuccess = _onSuccess;
    const serviceUrl =
      config.serverURL +
      config.api_routes.prefix +
      config.api_routes.modules.user.prefix +
      config.api_routes.modules.user.services.signin;

    try {
      const res = await fetch(serviceUrl, {
        headers: {
          'Access-Control-Allow-Origin': config.serverDomain,
          'Access-Control-Allow-Headers':
            'Origin, X-Requested-With, Content-Type, Accept',
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify(data),
      });
      const dataOut = await res.json();
      if (dataOut.respCode === 0) {
        localStorage.setItem(config.jwtTokenStoreName, dataOut.data.token);
        localStorage.setItem(
          config.localUserDTO,
          JSON.stringify(dataOut.data.user),
        );
        onSuccess(dataOut.data.user);
        resolve(dataOut);
      } else {
        localStorage.removeItem(config.jwtTokenStoreName);
        localStorage.removeItem(config.localUserDTO);
        if (dataOut.respCode === config.httpStatusCodes.UNAUTHORIZED) {
        }
        reject(dataOut);
      }
    } catch (e) {
      localStorage.removeItem(config.jwtTokenStoreName);
      localStorage.removeItem(config.localUserDTO);
      reject({
        respCode: -1,
        message: parseFetchError(e),
      });
    }
  });
};

const currentUser = () => {
  const token = getStoredToken();
  if (token && token !== 'undefined') {
    return new Promise(async (resolve, reject) => {
      try {
        const serviceUrl =
          config.serverURL +
          config.api_routes.prefix +
          config.api_routes.modules.user.prefix +
          config.api_routes.modules.user.services.currentUser;
        const res = await fetch(serviceUrl, {
          headers: {
            'Access-Control-Allow-Origin': config.serverDomain,
            'Access-Control-Allow-Headers':
              'Origin, X-Requested-With, Content-Type, Accept',
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: config.jwtTokenStoreName + ' ' + token,
          },
          credentials: 'include',
          method: 'POST',
        });
        const dataOut = await res.json();
        sessionChecker(dataOut);

        if (dataOut.respCode === 0) {
          resolve(dataOut);
        } else {
          reject(dataOut);
        }
      } catch (e) {
        reject({
          respCode: -1,
          message: parseFetchError(e),
        });
      }
    });
  } else {
    return sessionCloser();
  }
};

const signOut = () => {
  const token = getStoredToken();
  if (token) {
    return new Promise(async (resolve, reject) => {
      try {
        const serviceUrl =
          config.serverURL +
          config.api_routes.prefix +
          config.api_routes.modules.user.prefix +
          config.api_routes.modules.user.services.signout;
        const res = await fetch(serviceUrl, {
          headers: {
            'Access-Control-Allow-Origin': config.serverDomain,
            'Access-Control-Allow-Headers':
              'Origin, X-Requested-With, Content-Type, Accept',
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: config.jwtTokenStoreName + ' ' + token,
          },
          credentials: 'include',
          method: 'POST',
        });
        localStorage.removeItem(config.jwtTokenStoreName);
        const dataOut = { res };
        resolve(dataOut);
      } catch (e) {
        reject({
          respCode: -1,
          message: parseFetchError(e),
        });
      }
    });
  } else {
    return new Promise(async (resolve, reject) => {
      const dataOut = { respCode: -1 };
      resolve(dataOut);
    });
  }
};

const emailVerify = data => {
  return new Promise(async (resolve, reject) => {
    try {
      const serviceUrl =
        config.serverURL +
        config.api_routes.prefix +
        config.api_routes.modules.user.prefix +
        config.api_routes.modules.user.services.emailVerify;
      console.log('Contact: ' + serviceUrl);
      const res = await fetch(serviceUrl, {
        headers: {
          'Access-Control-Allow-Origin': config.serverDomain,
          'Access-Control-Allow-Headers':
            'Origin, X-Requested-With, Content-Type, Accept',
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify(data),
      });
      const dataOut = await res.json();
      if (dataOut.respCode === 0) {
        resolve(dataOut);
      } else {
        reject(dataOut);
      }
    } catch (e) {
      reject({
        respCode: -1,
        message: parseFetchError(e),
      });
    }
  });
};

const profileUpdate = data => {
  const token = getStoredToken();
  if (token) {
    return new Promise(async (resolve, reject) => {
      try {
        const serviceUrl =
          config.serverURL +
          config.api_routes.prefix +
          config.api_routes.modules.user.prefix +
          config.api_routes.modules.user.services.profileUpdate;
        const res = await fetch(serviceUrl, {
          headers: {
            'Access-Control-Allow-Origin': config.serverDomain,
            'Access-Control-Allow-Headers':
              'Origin, X-Requested-With, Content-Type, Accept',
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: config.jwtTokenStoreName + ' ' + token,
          },
          credentials: 'include',
          method: 'POST',
          body: JSON.stringify(data),
        });
        const dataOut = await res.json();
        sessionChecker(dataOut);
        resolve(dataOut);
      } catch (e) {
        reject({
          respCode: -1,
          message: parseFetchError(e),
        });
      }
    });
  } else {
    return sessionCloser();
  }
};

const changePassword = data => {
  const token = getStoredToken();
  if (token) {
    return new Promise(async (resolve, reject) => {
      try {
        const serviceUrl =
          config.serverURL +
          config.api_routes.prefix +
          config.api_routes.modules.user.prefix +
          config.api_routes.modules.user.services.changePassword;
        const res = await fetch(serviceUrl, {
          headers: {
            'Access-Control-Allow-Origin': config.serverDomain,
            'Access-Control-Allow-Headers':
              'Origin, X-Requested-With, Content-Type, Accept',
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: config.jwtTokenStoreName + ' ' + token,
          },
          credentials: 'include',
          method: 'POST',
          body: JSON.stringify(data),
        });
        const dataOut = await res.json();
        sessionChecker(dataOut);
        resolve(dataOut);
      } catch (e) {
        reject({
          respCode: -1,
          message: parseFetchError(e),
        });
      }
    });
  } else {
    return sessionCloser();
  }
};

const passwordResetRequest = data => {
  let formData = new FormData();

  formData.append('email', data.email);

  const serviceUrl =
    config.serverURL +
    config.api_routes.prefix +
    config.api_routes.modules.user.prefix +
    config.api_routes.modules.user.services.passwordResetRequest;

  return sendMultiPartRequest(serviceUrl, formData);
};

const passwordReset = data => {
  return new Promise(async (resolve, reject) => {
    try {
      const serviceUrl =
        config.serverURL +
        config.api_routes.prefix +
        config.api_routes.modules.user.prefix +
        config.api_routes.modules.user.services.passwordReset;
      const res = await fetch(serviceUrl, {
        headers: {
          'Access-Control-Allow-Origin': config.serverDomain,
          'Access-Control-Allow-Headers':
            'Origin, X-Requested-With, Content-Type, Accept',
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify(data),
      });
      const dataOut = await res.json();
      if (dataOut.respCode === 0) {
        resolve(dataOut);
      } else {
        reject(dataOut);
      }
    } catch (e) {
      reject({
        respCode: -1,
        message: parseFetchError(e),
      });
    }
  });
};

export {
  signIn,
  signOut,
  currentUser,
  profileUpdate,
  changePassword,
  passwordResetRequest,
  passwordReset,
  emailVerify,
};
